import { startCountdownBeep } from '@/assets/sounds/eventOngoingSound';

let activeBeepController: { stop: () => void; isActive: () => boolean } | null = null;

export async function playEventEdgeSound(): Promise<void> {
  if (typeof window === 'undefined') return;

  try {
    if (activeBeepController?.isActive()) {
      activeBeepController.stop();
    }

    activeBeepController = startCountdownBeep() ?? null;
  } catch {
    // Ignore lifecycle/audio errors; UI behavior must continue even when sound is blocked.
  }
}

